// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".buyOnlineContent-titleDealers-eOL {\n    letter-spacing: 0.0556rem;\n    font-size: 1rem;\n}\n\n.buyOnlineContent-dealersWrapper-P0P {\n}\n\n.buyOnlineContent-wrapper-qE9 {\n    height: 80vh;\n    overflow-y: auto;\n}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"titleDealers": "buyOnlineContent-titleDealers-eOL text-bronze text-center mb-5",
	"dealersWrapper": "buyOnlineContent-dealersWrapper-P0P flex flex-row md_flex-col flex-wrap md_flex-nowrap gap-2 md_gap-6",
	"wrapper": "buyOnlineContent-wrapper-qE9"
};
export default ___CSS_LOADER_EXPORT___;
